import React from 'react'

export default function ServicePage () {
  return (
    <div>
      <h1>ServicePage</h1>
      <p>We provide web applications development</p>
    </div>
  )
}
